import React, { Component } from 'react';
import RadioButton from './RadioButton';

export default class NumericRating extends Component {
  render(){
    const {
      numberOfPositions,
      value,
      onSelectedNumber
    } = this.props;
    const recommendList = [...Array(numberOfPositions)].map( (_, index) => {
    	return (
        <RadioButton
          key={index}
          id={`numericRating${index}`}
          name="recommend"
          type="radio"
          label={index}
          value={value}
          onChange={onSelectedNumber.bind(this, index)}
        />
    	);
    });
    return <div className="recommend-container">{recommendList}</div>
  }
};



// WEBPACK FOOTER //
// ./src/components/NumericRating.js